// extracted by mini-css-extract-plugin
module.exports = {"panel":"FaceRecognition_panel__1x5k_"};